/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { LoginForm } from "./LoginForm";
import { Suspense } from "react";
import { ForgotPassForm } from "../../../application/components/ForgotPassForm";
import { VerifyForm } from "../../../application/components/VerifyForm";
const LoginPage = (param)=>{
    let { params: { lng } } = param;
    const [view, setView] = useState("login");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [verifyMessage, setVerifyMessage] = useState("");
    const [verifyMessageType, setVerifyMessageType] = useState("info");
    return /*#__PURE__*/ _jsxs(Suspense, {
        children: [
            view === "login" && /*#__PURE__*/ _jsx(LoginForm, {
                lng: lng,
                hanleForgotPassword: (forgotPassword)=>setView(forgotPassword ? "forgot" : "login"),
                handleRequireVerification: function(emailAddress, userPassword, message) {
                    let messageType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "info";
                    setEmail(emailAddress);
                    setPassword(userPassword);
                    setVerifyMessage(message);
                    setVerifyMessageType(messageType);
                    setView("verify");
                }
            }),
            view === "forgot" && /*#__PURE__*/ _jsx(ForgotPassForm, {
                lng: lng
            }),
            view === "verify" && /*#__PURE__*/ _jsx(VerifyForm, {
                lng: lng,
                email: email,
                password: password,
                initialMessage: verifyMessage,
                initialMessageType: verifyMessageType
            })
        ]
    });
};
export default LoginPage;
